// Copyright (c) Docugami, Inc. All rights reserved.

export const userFontFamily = 'Lato';
export const dgFontFamily = 'Montserrat';
export const dgTagFontFamily = 'Roboto Condensed';

export const primaryFontExpanded = "'" + userFontFamily + "', sans-serif";
export const primaryContentFont = "'" + dgFontFamily + "', sans-serif";
export const tagFont = "'" + dgTagFontFamily + "', sans-serif";
